import React from 'react';

import { mapIndexed } from 'utils/ramdaAdditions';
import { Line } from 'components/common/tableComponents/cellTemplates/index';

export default function Classifiers ({ value : classifiers }) {
    let line = 0;

    return (
        <div className="project-classifier">
            { mapIndexed((item, index) => (
                <div key={index} className="project-classifier-col">
                    <b>
                        <Line index={line++}>
                            {item.name}
                        </Line>
                    </b>
                    <ul>
                        { mapIndexed((part, index) => (
                            <li key={index}>
                                <Line index={line++}>
                                    {part.text}
                                </Line>
                            </li>
                        ), item.classifier || [])}
                    </ul>
                </div>
            ), classifiers || [])}
        </div>
    );
}
